import React from 'react'

import { useDispatch } from 'react-redux'

import {Card, CardActions, CardContent, CardMedia, Button, Typography} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import ModeEditIcon from '@mui/icons-material/ModeEdit';

import useStyles from './styles.js'

import avatar from '../../../images/empty_competition.png'
import { deleteCompetition } from '../../../actions/competitions.js'
import { isAdminUser } from '../../../actions/auth.js'

const Competition = ({ competition, setCurrentId, reload }) => {
    const classes = useStyles();

    const dispatch = useDispatch()


    
    return (
        <Card className={classes.card}>
            <CardMedia className={classes.media} image={competition.photo || avatar} title={competition.name}/>

            <CardContent>
                <Typography className={classes.title} variant="h5" gutterBottom>{competition.name}</Typography>
            </CardContent>

            <CardActions className={classes.cardActions}>
            {isAdminUser() && <Button size="small" color="primary" onClick={() => {dispatch(deleteCompetition(competition._id)); reload()}}>
                    <DeleteIcon fontSize="small"/>
                    Supprimer
                </Button>}

                <Button size="small" color="primary" onClick={() => {setCurrentId(competition._id)}}>
                    <ModeEditIcon fontSize="small" />
                    Editer
                </Button>
            </CardActions>
        </Card>
    )
}

export default Competition